import React, { useMemo } from "react";
import { Column } from "react-table";

import { Organization } from "types/organization";
import DataTable from "components/DataTable";
import OrganizationRow from "./OrganizationRow";

interface Props {
  organizations: Organization[];
}

const OrganizationsDataTable: React.FC<Props> = ({ organizations }: Props) => {
  const data: Organization[] = useMemo(() => organizations, [organizations]);
  const columns: Column<Organization>[] = useMemo(
    () => [
      {
        accessor: "id",
        disableSortBy: true,
        Cell: ({ row: { original } }: any) => (
          <OrganizationRow organization={original} />
        )
      },
      {
        accessor: "name",
        disableSortBy: true
      },
      {
        Header: "Name",
        accessor: "displayName"
      },
      {
        accessor: "billingAddress",
        disableSortBy: true
      },
      {
        accessor: "rate",
        disableSortBy: true
      }
    ],
    []
  );

  return <DataTable columns={columns} data={data} tableTitle="Organizations" />;
};

export default OrganizationsDataTable;
